import { createContext } from 'react';

export const LEGACY_FEATURE_KEY = 'legacy' as const;

export type LegacyValue = 'true' | 'false' | null;

export type LegacyContext = {
    legacy: boolean;
    toggleLegacy: (value?: boolean) => void;
};

export const LegacyContext = createContext<LegacyContext | null>(null);
